class RestService {
  prepareRequestDetails(identityToken, projectId, _headers) {
    let headers = _headers || {
      "Content-Type": "application/json",
      accept: "application/json",
    };
    const requestDetails = {
      headers,
      mode: "cors",
      credentials: "include",
    };

    if (identityToken) {
      requestDetails.headers["x-mstr-authtoken"] = identityToken;
    }

    if (projectId) {
      requestDetails.headers["X-MSTR-ProjectID"] = projectId;
    }

    return requestDetails;
  }

  async sendRequest(url, options, ignoreUnauthorized) {
    const res = await fetch(url, options);

    if (!ignoreUnauthorized && res.status === 401) {
      // throw new UnauthorizedError();
    }

    return res;
  }

  async get(url, identityToken, projectId, ignoreUnauthorized) {
    const requestDetails = this.prepareRequestDetails(identityToken, projectId);

    const options = {
      method: "GET",
      ...requestDetails,
    };

    return this.sendRequest(url, options, ignoreUnauthorized);
  }

  async post(url, body, identityToken, projectId, headers) {
    const requestDetails = this.prepareRequestDetails(identityToken, projectId, headers);

    if (!(body instanceof URLSearchParams)) {
      body = JSON.stringify(body);
    } else {
      body = body.toString();
    }
    const options = {
      method: "POST",
      body,
      ...requestDetails,
    };

    return this.sendRequest(url, options);
  }

  async put(url, body, identityToken, projectId) {
    const requestDetails = this.prepareRequestDetails(identityToken, projectId);

    const options = {
      method: "PUT",
      body: JSON.stringify(body),
      ...requestDetails,
    };

    return this.sendRequest(url, options);
  }

  async delete(url, body, identityToken, projectId) {
    const requestDetails = this.prepareRequestDetails(identityToken, projectId);

    const options = {
      method: "DELETE",
      body: JSON.stringify(body),
      ...requestDetails,
    };

    return this.sendRequest(url, options);
  }
}

export const restService = new RestService();
